import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import {
  IInventoryPurchaseOrderProductSearchResponse,
  IInventoryPurchaseOrderProductSearchResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useInventoryProductSearchAPI = () => {
  const configuration = useConfiguration();
  const [searchResults, setSearchResults] = useState<IInventoryPurchaseOrderProductSearchResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const clearSearchResults = () => {
    setSearchResults([]);
  };
  const execute = useCallback(
    async (searchQuery: string, variant_category_id: string, moduleType?: "PO", warehouseType?: string, clinic_id?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const baseURL = `${INVENTORY_MODULE?.PURCHASE_ORDER_PRODUCT_SEARCH?.baseURL}`;
        const params: Record<string, string | undefined> = {
          search: searchQuery,
          variant_category_id: variant_category_id || undefined,
        };
        // Add module-specific parameters
        if (moduleType === "PO") {
          params.section = "PO";
          params.warehouse_type = warehouseType; // Add warehouse type
          params.clinic_id = clinic_id; // Add clinic_id
        }
        const response = await axios
          .get(baseURL, {
            params,
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryPurchaseOrderProductSearchResponse>) => {
            if (res.data.status === true && res.data) {
              setSearchResults(res.data.data);
              return res.data.data;
            } else {
              setSearchResults([]);
              return [];
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setSearchResults([]);
            captureError(e);
            return [];
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { searchResults, clearSearchResults, execute };
};
